import { useTranslation } from 'react-i18next'

import Text from '../../Text'

function EmptyListItemContent({ text }) {
  const { t } = useTranslation()

  return <Text isSecondary>{text || t('Select.NoDataKey')}</Text>
}

export default EmptyListItemContent
